import React, { useEffect, useEffectEvent, useRef, useState } from "react"
import { Avatar, Box, Button, Container, Divider, Grid, IconButton, Stack, Toolbar, Typography, styled } from "@mui/material"
import { Camera as IconCamera, Cancel, Check, ImageSearchSharp, CameraAlt } from "@mui/icons-material";
import { isEmpty } from "../../services/utils";
import Resizer from "react-image-file-resizer";
import Modal from "../modal";
import CameraImage from "./camera";


const FileInput = ({ value, onChange, ...rest }: any) => {
    const inputRef = useRef({} as any);
    const resizeFile = (file: any) => {
        console.log("file", file);
        return new Promise((resolve) =>
            Resizer.imageFileResizer(
                file,
                500,
                500,
                "JPEG",
                100,
                0,
                (uri) => {
                    console.log("uri", uri)
                    resolve(uri);
                },
                "blob"
            )
        )
    }

    const handleOnChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
        let blob = await resizeFile(e.target.files![0]) as Blob;
        onChange(URL.createObjectURL(blob))
    }

    return <input {...rest} style={{ display: 'none' }} type="file" accept="image/*" ref={inputRef} onChange={handleOnChange} />;
};

interface AnexarProps {
    open: boolean
    setOpen: (set: boolean) => void;
    confirmar: (img: Blob|any) => void;
    anexoAtual: string;
    urlAtual: string;
    returnUrl?:boolean
}



interface ViewCameraProps {
    open: boolean,
    handleClose: () => void,
    callbackTakePhoto:(value:string)=>void
}

const ViewCamera = (props: ViewCameraProps) => {

    const confirmaPhoto = (value:string) =>{
        props.callbackTakePhoto(value);
        props.handleClose()
    }

    return (
        <Modal
            component={
                <>{props.open&&(<CameraImage callback={confirmaPhoto} cancel={props.handleClose}/>)}</>
            }
            handleClose={props.handleClose}
            heigth="auto"
            width="md"
            open={props.open}
            sx={{zIndex:1400}}
        />
    )
}

function Anexar(props: AnexarProps) {
    console.log("anexar props",props)
    const [showViewCamera, setShowViewCamera] = useState(false);
    const [img, setImg] = useState("")
    const [title, setTitle] = useState(isEmpty(props.anexoAtual) ? "Adicionar Imagem" : "Alterar Imagem")

/*     useEffect(()=>{
        setImg(props.urlAtual)
    },[props.urlAtual]) */

    const previewImg = (img: string) => {
        if (img !== "") {
            setImg(img);
            setTitle("Confirmar imagem selecionada?")
        }
    }

    const cancelPreview = () => {
        setImg("");
        setTitle(isEmpty(props.anexoAtual) ? "Adicionar Imagem" : "Alterar Imagem")
    }

    const sendBlobImg = async (url: string) => {
        if(!props.returnUrl){
            let blob = await fetch(url).then(r => r.blob());
            props.confirmar(blob);    
        } else {
            props.confirmar(url);    
        }
    }


    const Content = () => {
        return (
            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                <Toolbar>
                    <Typography variant="h6" sx={{ flex: 1 }} >{title}</Typography>

                </Toolbar>
                <Divider />
                <Container sx={{ display: 'flex', flex: 1, flexDirection: 'column', justifyContent: 'center', alignContent: 'center' }}>
                    <ViewCamera callbackTakePhoto={previewImg} open={showViewCamera} handleClose={() => setShowViewCamera(false)} />
                    <Box sx={{ display: 'flex', flexDirection: 'column', padding: 5 }}>
                        <Avatar
                            variant="rounded"
                            src={img ? img : props.urlAtual}
                            style={{ width: 150, height: 150, alignSelf: 'center', padding: 5,objectFit:"cover" }}
                        />
                        {img !== "" && (
                            <Stack direction={'row'} spacing={2} justifyContent={'center'}>
                                <IconButton color="success" size="large" onClick={() => sendBlobImg(img)}><Check fontSize="inherit" /></IconButton>
                                <IconButton color="secondary" onClick={cancelPreview}><Cancel fontSize="inherit" /></IconButton>
                            </Stack>
                        )}

                    </Box>

                    {img === "" && (
                        <Stack direction={"row"} justifyContent={"space-evenly"} flex={1} >
                            <Button
                                id="getImage"
                                color="primary"
                                component="label"
                                role={undefined}
                                variant="text"
                                tabIndex={-1}
                                startIcon={<ImageSearchSharp fontSize="large" />}
                                size="large"
                            >
                                <FileInput onChange={previewImg} />
                                Buscar Imagem
                            </Button>
                            <IconButton
                                size="large"
                                onClick={() => setShowViewCamera(true)}
                            >
                                <CameraAlt />
                            </IconButton>
                        </Stack>
                    )}

                </Container>

            </Box>
        )
    }
    const { open, setOpen } = props;
    return (
        <Modal
            component={<Content />}
            handleClose={()=>setOpen(false)}
            heigth="auto"
            width="sm"
            handleOnKeyDown={()=>{}}            
            open={open}
        />
    )
}

export default Anexar